import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Results from '../Results';
import SearchInput from '../SearchInput';

const SearchTab = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);

  return (
    <Box m="auto" maxWidth="1400px" width="90%">
      <SearchInput
        loading={loading}
        setLoading={setLoading}
        setError={setError}
        setData={setData}
      />

      <Results
        data={data}
        setPaginationLoading={setPaginationLoading}
        setError={setError}
        setData={setData}
        error={error}
        loading={loading}
        paginationLoading={paginationLoading}
      />
    </Box>
  );
};

export default SearchTab;
